import React from 'react';

const Orders = () => {
	return <div>Orders will show here</div>;
};

export default Orders;
